import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import {
  __config_loyalty,
  getAccountState,
  getBonusPointsState,
  getCustomerConfigState
} from '../../../redux/reducers';
import { distinctUntilChanged, filter, map, tap } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-loyalty-widget',
  templateUrl: './loyalty-widget.component.html',
  styleUrls: ['./loyalty-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoyaltyWidgetComponent implements OnInit {
  // @loyaltyDocs: widget component
  // this component is placed on the header of the portal
  // It has two states:
  //  1. the user has access to the loyalty system and his bonus points are displayed to him
  //  2. the user cannot access the loyalty system, and clicking on the icon redirects it to the registration page
  // Whether the loyalty system is on or not is determined by the config parameters (ngrx selectors):
  //  - "getAccountState" - Is there a loyalty account?
  //  - "__config_loyalty" - Is the loyalty system for the market turned on?
  //  - "getCustomerConfigState" - Is the loyalty system for the current user turned on?
  //  - "getBonusPointsState" - directly bonuspoints

  widgetConfig$: Observable<any>;

  // localize
  readonly accountFirstConnectedHeaderTooltipString = $localize`:@@loyalty-widget.accountFirstConnectedHeaderTooltip:
  Your available points on Amadeus+Me.Click on the icon to check details`;

  constructor(private readonly store: Store<any>, private readonly cd: ChangeDetectorRef) {}

  ngOnInit() {
    this.widgetConfig$ = combineLatest([
      this.store.pipe(
        select(getBonusPointsState),
        filter(state => !state.isLoading),
        map(state => state.data)
      ),
      this.store.pipe(
        select(getAccountState),
        filter(state => !state.isLoading),
        map(state => Boolean(state.agentNumber))
      ),
      this.store.pipe(
        select(__config_loyalty),
        filter(state => !state.isLoading && state.config !== undefined),
        map(state => state.config),
        distinctUntilChanged()
      ),
      this.store.pipe(
        select(getCustomerConfigState),
        filter(state => !state.isLoading),
        map(state => state.customerConfig)
      )]
    ).pipe(
      map(([pointsData, enrolled, loyaltyConfig, customer]) => ({
        points: pointsData && pointsData.available,
        enabled: loyaltyConfig.enabled_for_market,
        link: this.getLink(enrolled, customer.is_decision_maker, customer.loyalty_enabled_for_account)
      })),
      tap(() => this.cd.detectChanges())
    );
  }

  private getLink(enrolled: boolean, dm: boolean, accountEnabled: boolean) {
    const config = '' + +enrolled + +dm + +accountEnabled;
    switch (config) {
      case '110':
      case '111':
      case '101':
        return '/amadeus-plus-me/bonuspoints';
      case '010':
        return '/amadeus-plus-me/participation';
    }
    return '/amadeus-plus-me/enrollment';
  }
}
